import React from 'react';
import { X, Trash2, Loader2 } from 'lucide-react';

const DeleteConfirmationPopup = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Item",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  isLoading = false,
  confirmLabel = "Delete",
  confirmLoadingLabel = "Deleting...",
  confirmIcon = <Trash2 size={16} />,
  confirmVariant = "danger"
}) => {
  if (!isOpen) return null;

  const confirmClass = confirmVariant === "danger"
    ? "border border-red-600 text-red-600 hover:bg-red-50"
    : confirmVariant === "accent"
      ? "bg-accent-600 text-white hover:bg-accent-700"
      : "border border-gray-300 text-gray-700 hover:bg-gray-50";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            disabled={isLoading}
            className={`px-4 py-2 rounded-md text-sm font-medium flex items-center space-x-1 transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200 ${
              isLoading && 'opacity-50 cursor-not-allowed'
            }`}
          >
            <X size={16} />
            <span>Cancel</span>
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`px-4 py-2 rounded-md text-sm font-medium flex items-center space-x-1 transition-colors ${confirmClass} ${
              isLoading && 'opacity-50 cursor-not-allowed'
            }`}
          >
            {isLoading ? <Loader2 size={16} className="animate-spin" /> : confirmIcon}
            <span>{isLoading ? confirmLoadingLabel : confirmLabel}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationPopup;
